import { useQuery } from '@tanstack/react-query'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches the viewer's region's schedule templates, archived ones included. */
export function useScheduleTemplates() {
  const api = useOsApi()
  const { region } = useViewerRegion()

  return useQuery({
    queryKey: ['schedule-templates', region],
    queryFn: async () => {
      const response = await api.get('/schedules/templates', { query: { region } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.templates
    },
  })
}
